<template>
  <div class="app-container">
    <Toast />
    <ConfirmDialog group="global" :rejectVisible="false" @hide="onDialogHide"/>

    <TopNavBar :isLoggedIn="isLoggedIn" />

    <div class="app-content">
      <router-view />
    </div>
  </div>
</template>

<script>
import TopNavBar from "@/components/TopNavBar";
import { useStore } from "vuex";
import { computed, watch, ref } from "vue";
import { useConfirm } from "primevue/useconfirm";
import AuthRepository from "@/services/AuthRepository";

export default {
  components: { TopNavBar },

  setup() {
    const store = useStore();
    const confirm = useConfirm();

    const isLoggedIn = computed(() => !!store.state.token);
    const dialogShown = ref(false);

    watch(
        isLoggedIn,
        async (loggedIn) => {
          if (!loggedIn || dialogShown.value) return;

          dialogShown.value = true; // 🔒 chạy đúng 1 lần

          try {
            const response = await AuthRepository.getNotification();
            const message = response?.data?.message;

            if (!message) return;

            if (store.getters.shouldShowDailyPopup) {
              confirm.require({
                group: "global",
                header: "🔔 Thông báo hệ thống",
                message:
                    "🌸🌸🌸 Hôm nay hệ thống có thông báo 🌸🌸🌸\n" +
                    message,
                acceptLabel: "Đã hiểu",
                rejectVisible: false,
                closable: false,
                acceptClass: "spa-confirm-accept"
              });

              // ✅ đánh dấu NGAY
              store.commit("markDailyPopupShown");
            }
          } catch (err) {
            console.error("Daily popup error:", err);
          }
        },
        { immediate: true } // 🔥🔥🔥 DÒNG QUYẾT ĐỊNH
    );

    const menuSwipe = ref(null)
    const confirmVisible = ref(false)

    const resetHorizontalScroll = () => {
      const el = menuSwipe.value
      if (!el) return
      el.style.scrollBehavior = 'auto'
      el.scrollLeft += 1
      el.scrollLeft -= 1
    }
    const onDialogHide = () => {
      requestAnimationFrame(() => {
        resetHorizontalScroll()
      })
    }

    return {
      isLoggedIn,
      onDialogHide
    };
  }
};
</script>

<style lang="scss">
.app-container {
  margin: 0 auto;
  max-width: 1200px;
  width: 100%;
  background: #f7f8f9;

  .app-content {
    margin: 10px 8px 50px;
  }
}
</style>
